/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const Refresh: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 3C8.1656 3 4.964 5.3719 3.6562 8.7188l1.3828.5625C6.1313 6.478 8.7845 4.5 12 4.5c2.4328 0 4.5984 1.1906 5.9531 3H15V9h5.25V3.75h-1.5v2.3203C17.1047 4.186 14.6766 3 12 3m6.9609 11.7188C17.8687 17.5219 15.2156 19.5 12 19.5c-2.4563 0-4.6172-1.2094-5.9766-3H9V15H3.75v5.25h1.5v-2.3203C6.8906 19.7906 9.2953 21 12 21c3.8344 0 7.0359-2.3719 8.3437-5.7188z"/></svg>
);

export default Refresh;
